import { BANNER_CONSTANTS } from './banner-constants';
var BannerFoundation = /** @class */ (function () {
    function BannerFoundation(_adapter) {
        var _this = this;
        this._adapter = _adapter;
        this._dismissed = false;
        this._canDismiss = true;
        this._dismissBanner = function () { return _this._dismiss(); };
    }
    BannerFoundation.prototype.connect = function () {
        this._addDismissEventListener();
    };
    BannerFoundation.prototype.disconnect = function () {
        this._removeDismissEventListener();
    };
    BannerFoundation.prototype._dismiss = function () {
        this.dismissed = true;
    };
    BannerFoundation.prototype._syncDismissedState = function () {
        if (this.dismissed) {
            this._setDismissedClass();
            this._adapter.emitHostEvent(BANNER_CONSTANTS.events.DISMISSED);
        }
        else {
            this._setUndissmissedClass();
            this._adapter.emitHostEvent(BANNER_CONSTANTS.events.UNDISMISSED);
        }
    };
    BannerFoundation.prototype._setUndissmissedClass = function () {
        this._adapter.removeRootClass(BANNER_CONSTANTS.classes.DISMISSED);
    };
    BannerFoundation.prototype._setDismissedClass = function () {
        this._adapter.addRootClass(BANNER_CONSTANTS.classes.DISMISSED);
    };
    BannerFoundation.prototype._syncCanDismissState = function () {
        if (this.canDismiss) {
            this._adapter.removeDismissButtonAttribute(BANNER_CONSTANTS.attributes.HIDDEN);
        }
        else {
            this._adapter.addDismissButtonAttribute(BANNER_CONSTANTS.attributes.HIDDEN);
        }
    };
    BannerFoundation.prototype._addDismissEventListener = function () {
        this._adapter.addDismissEventListener('click', this._dismissBanner);
    };
    BannerFoundation.prototype._removeDismissEventListener = function () {
        this._adapter.removeDismissEventListener('click', this._dismissBanner);
    };
    Object.defineProperty(BannerFoundation.prototype, "dismissed", {
        get: function () {
            return !!this._dismissed;
        },
        set: function (val) {
            if (this.dismissed === !!val) {
                return;
            }
            this._dismissed = !!val;
            this._syncDismissedState();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BannerFoundation.prototype, "canDismiss", {
        get: function () {
            return !!this._canDismiss;
        },
        set: function (val) {
            if (this._canDismiss === !!val) {
                return;
            }
            this._canDismiss = !!val;
            this._syncCanDismissState();
        },
        enumerable: true,
        configurable: true
    });
    return BannerFoundation;
}());
export { BannerFoundation };
